<template>
  <v-dialog v-model="projectDialog" width="500">
    <v-card>
      <v-card-title
        class="headline"
        primary-title
      >
        {{ project.title }}
        <skill-bar :skills="project.skills" />
      </v-card-title>

      <v-divider />
      <v-card-text
        class="text-xs-left"
        v-html="project.long_description"
      />

      <v-divider />
      <v-card-actions>
        <v-btn flat
          v-for="(link, index) in project.links"
          :key="index"
          :href="link.url" target="_blank"
        >
          {{ link.title }}
        </v-btn>

        <v-spacer />
        <v-btn flat @click="projectDialog = false">
          Close
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import SkillBar from '@/components/projects/SkillBar.vue';

export default {
  props: ['dialog', 'project'],
  components: {
    'skill-bar': SkillBar,
  },

  computed: {
    projectDialog: {
      get() { return this.dialog },
      set(value) { if (!value) this.$emit('close') }
    },
  },
};
</script>
